import React, { Component } from 'react';
import * as GServ from '../services/GatewayService';
import { Button, CircularProgress } from '@material-ui/core';

class PaymentFail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSpinner: true,
            status: "Please bear with us while we check on the status of your application. Please don't close this page...",
            warning: '',
            mainHeadText: '',
            formDetails: {},
            confirmed: false,
            showError: false,
        }
    }
    
    componentDidMount() {
        // console.log('calling checkToken...');
        this.fetchAppReceipt();
    }
    
    render() {
        let missingQparms = false;
        if (!this.props.qparms.token||!this.props.qparms.entry){missingQparms=true}

        return (
            <div style={{maxWidth:900}}>

                {missingQparms&&
                <div>
                    <h3>Technical Error</h3>
                    Unfortunately a technical error was encountered when we tried to process your application.<br/>
                    If this problem persists, please contact us.
                </div>}
                
                {!missingQparms&&
                <div>
                    <h3>Oops...Something went wrong!</h3>
                   
                    <p>It seems we were unable to process payment for your registration that time.</p>

                    {!this.state.showSpinner&&!this.state.confirmed&&
                    <span><b>{this.state.mainHeadText}</b></span>} 

                    {this.state.confirmed&&
                    <div>
                        <p>
                            Your registration process is <b>almost complete</b> though - we just need to process payment. <i>Would you like to try again?</i>
                        </p>

                        <Button 
                            variant='contained'
                            color='primary'    
                            onClick={this.backToPayGate}    
                        >
                            Back to Payment Portal
                        </Button>

                        <p>
                            If you are having difficulty with the payment process, or if you need any help with your registration, please feel free to contact us - 
                            <br/><br/>
                            <a href={'mailto:' + this.state.formDetails.enquiries_mail}>{this.state.formDetails.enquiries_mail}</a>
                            <br/><br/>
                            <a href={this.state.formDetails.redirect_url} target="_top">Home</a>
                        </p>
                   </div>}

                    <hr/>
                    
                    <span id="StatusBar" className="StatusBar">
                        {this.state.showSpinner&&<CircularProgress size={30} />}&nbsp;&nbsp;
                        {this.state.status}
                    </span>
                    <span className='warningMessage'>{this.state.warning}</span>
                    <br/>
                    <br/>

                </div>}

            </div>
        );
    }

    fetchAppReceipt = () => {
        // console.log('Called fetchAppReceipt');
        GServ.confirmReceipt(this.props.qparms.token,this.props.qparms.entry)
        .then(reply => {
            // console.log('fetchAppReceipt reply => ',reply);
            if (reply.Result==='Expired'){
                this.setState({showSpinner:false,mainHeadText:'Expired', status:"This online form has unfortunately expired. Our online registration form is usually valid for 24 hours from when it's first generated. You're more than welcome to follow the original links and submit a fresh application, but if you feel you need any assistance please don't hesitate to contact us.",confirmed:false});
            } else if (reply.Result==='Failed'&&reply.Message!=='Unable to contact Gateway Prime Server'){
                this.setState({showSpinner:false,mainHeadText:'Invalid Link', status:'',warning:"We're unable to process your form currently, as it seems to have been submitted via an invalid or unauthorised link. If this problem persists, please contact us.",confirmed:false});
            } else if (reply.Message==='Form not open for entry'){
                this.setState({showSpinner:false,mainHeadText:'Submissions are Closed', status:"Our online form is not currently open for submissions unfortunately. Should you have any queries, please don't hesitate to contact us.", warnning:"",confirmed:false});
            } else if (reply.Payload.receipt_status!=='Published'){
                // console.log("Message wasn't published. fetchAppReceipt reply => ",reply);
                this.setState({showSpinner:false,mainHeadText:'Technical Error', status:'',warning:"We apologise, but we seem to have encountered a technical issue and are unable to process your form at the moment. If this problem persists, please contact us.",confirmed:false});
            } else if (reply.Result !=='Success' || !reply.Payload.form_has_paygate || !reply.Payload.paygate_url){
                // console.log('fetchAppReceipt reply: caught unkown failure => ',reply);
                this.setState({showSpinner:false,mainHeadText:'Technical Error', status:"", warning:"We apologise, but we're not able to process your form at the moment due to a technical error. If this problem persists, please contact us.",confirmed:false});
            } else {
                //i.e. Result = Success
                // console.log('Receipt ok');
                // console.log('fetchAppReceipt reply => ',reply);
                this.setState({showSpinner:false,formDetails:reply.Payload, status:'',warning:'', confirmed:true});
            }
        });
    }

    backToPayGate = () => {
        // console.log('Clicked back to paygate...');
        this.setState({showSpinner:true,status:'Connecting to payment portal...'})

        let paygate_url = this.state.formDetails.paygate_url;

        // console.log('initial paygate_url :>> ',paygate_url);

        //populate placeholders in url string...
        paygate_url = paygate_url.replace("[Contact_Email]",this.state.formDetails.contact_email);
        paygate_url = paygate_url.replace("[AppMQ_ID]",this.props.qparms.entry);
        paygate_url = paygate_url.replace("[Item]",this.state.formDetails.paygate_item);
        paygate_url = paygate_url.replace("[Amount]",this.state.formDetails.paygate_amount);
        paygate_url = paygate_url.replace("[Return_Url]","https://prime-entry.web.app?op=S" + this.props.qparms.entry+ "~" + this.props.qparms.token); 
        paygate_url = paygate_url.replace("[Cancel_Url]","https://prime-entry.web.app?op=F" + this.props.qparms.entry + "~" + this.props.qparms.token);

        // console.log('final paygate_url :>> ', encodeURI(paygate_url));

        window.parent.location.href = encodeURI(paygate_url);      

    }
    
}

export default PaymentFail;